import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { InfoIcon } from 'src/domains/layouts/shared/assets/icons/InfoIcon';

export const RemainingLimitWrapper = withConfig(theme => styled('div', { label: 'RemainingLimitWrapper' })`
    display: flex;
    font-size: ${theme.star.fontSize.small};
    background-color: ${theme.star.topUp.bgColor};
    margin-top: 24px;
    padding: 12px;
    border-radius: 8px;
    height: 64px;
`);

export const DepositText = withConfig(theme => styled('div', { label: 'DepositText' })`
    color: ${theme.star.topUp.txtColor};
`);

export const DepositLimitWrapper = styled('div', { label: 'DepositLimitWrapper' })`
    display: flex;
    flex-direction: column;
    margin-left: 12px;
    margin-top: -5px;
`;

interface DespositLimitsLinkPropsType {
    isSignup: boolean;
}


export const DepositLimitsLink = withConfig(theme => styled(Link, { label: 'DepositLimitsLink' })<DespositLimitsLinkPropsType>`
    color: ${({ isSignup }): string => isSignup ? theme.star.signUp.txtColorSecondary : theme.star.accountDrawer.txtColorSecondary};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    text-decoration: none;
`);

export const InfoIconWrapper = withConfig(theme => styled(InfoIcon, { label: 'InfoIconWrapper' })`
    width: 16px;
    fill: ${theme.star.topUp.iconColor};
    align-self: flex-start;
`);
